<ng-container *transloco="let t">
<div class="modal-header">

  <h2>{{header}}</h2>

  <!-- hack to fool ngbModal autofocus -->
  <input type="text" style="display:none" />

  <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" aria-label="Close"
    (click)="activeModal.dismiss('Cross click')">
    <span class="svg-icon svg-icon-2x">
      <close-x-svg-icon></close-x-svg-icon>
    </span>
  </div>
</div>

<div class="modal-body py-10 px-lg-17">
  <form #incomeInfoForm="ngForm" class="form" novalidate id="incomeInfoForm" name="incomeInfoForm">
    <div class="row mb-5">
      <div class="col-md-6 fv-row">
        <label class="required form-label mb-2">{{ t('wizard.employment.borrower') }}</label>
        <borrower-picker [required]="true" [ngModelOptions]="{standalone: true}" [(ngModel)]="income.borrowerId" [borrowers]="borrowers"></borrower-picker>
      </div>
      <div class="col-md-6 fv-row">
      </div>
    </div>

    @if (editorIncomeType === 'OtherTypesOfIncome') {
      <div class="me-n7 pe-7">
        <div class="row g-9 mb-5">
          <div class="col-md-12 fv-row">
            <label class="required form-label mb-2">{{ t('wizard.income.typeOfIncome') }}</label>
            <select name="incomeType" required
              [ngClass]="{'is-invalid' : incomeType && incomeType.touched && incomeType.invalid}"
              #incomeType="ngModel" class="form-select form-select-solid" [(ngModel)]="income.typeOfIncome"
              data-control="select2" data-hide-search="true" data-placeholder="Choose one">
              <option></option>
              @for (otherIncomeType of otherIncomeTypes; track otherIncomeType.value) {
                <option [ngValue]="otherIncomeType.value">{{otherIncomeType.name}}</option>
              }
            </select>
            <div class="invalid-feedback">{{ t('wizard.employment.pleaseSelectValue') }}</div>
              </div>
        </div>
      </div>
    }

    @if (editorIncomeType === 'OtherTypesOfIncome' && income.typeOfIncome === 'OtherTypesOfIncome' && !isHidden('income.typeOfIncomeOtherDescription')) {
      <div class="me-n7 pe-7">
        <div class="row g-9 mb-5">
          <div class="col-md-12 fv-row">
            <label class="form-label mb-2" [ngClass]="{'required': isRequired('income.typeOfIncomeOtherDescription')}">
              {{getLabel('income.typeOfIncomeOtherDescription', t('wizard.income.description'))}}
            </label>
            <input class="form-control form-control-solid"
              [ngClass]="{'is-invalid' : description && description.touched && description.invalid}"
              #description="ngModel" [required]="isRequired('income.typeOfIncomeOtherDescription')"
              [(ngModel)]="income.typeOfIncomeOtherDescription" placeholder="" name="description" />
            <div class="invalid-feedback">{{ t('wizard.income.descriptionRequired') }}</div>
          </div>
        </div>
      </div>
    }

    @if (!isHidden('income.monthlyIncome')) {
      <div class="me-n7 pe-7">
        <div class="row g-9 mb-5">
          <div class="col-md-12 fv-row">
            <label class="form-label mb-2" [ngClass]="{'required': isRequired('income.monthlyIncome')}">{{label}}</label>
            <input class="form-control form-control-solid" mask="separator" thousandSeparator="," inputmode="decimal" prefix="$"
              [ngClass]="{'is-invalid' : monthlyIncome && monthlyIncome.touched && monthlyIncome.invalid}"
              #monthlyIncome="ngModel" [required]="isRequired('income.monthlyIncome')"
              [(ngModel)]="income.monthlyIncome" placeholder="" name="monthlyIncome" />
            <div class="invalid-feedback">{{ t('wizard.employment.monthlyPayRequired') }}</div>
          </div>
        </div>
      </div>
    }

    @if (showEcoaOtherIncomeNotice) {
      <div class="notice bg-light-primary rounded border-primary border border-dashed p-4 fs-7 text-gray-700" data-testid="ecoa-other-income-notice">
        {{ t('wizard.income.ecoaOtherIncomeNotice') }}
      </div>
    }

  </form>
</div>

<div class="modal-footer flex-center">
  <button type="button" class="btn btn-white me-3" (click)="activeModal.dismiss()">{{ t('common.cancel') }}</button>
  <button type="button" class="btn btn-primary" (click)="onSaveClicked()">{{ t('common.ok') }}</button>
</div>
</ng-container>
